<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div id="app" :class="vueAppClasses">
		<router-view @setAppClasses="setAppClasses" />
	</div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'

import firebase from 'firebase/app'
import 'firebase/auth'

import 'firebase/functions'

export default {
  data() {
    return {
      vueAppClasses: [],
      updatedCheck: false
    }
  },
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl'(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
    }
  },
  methods: {
    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      }
      else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      }
      else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    },
    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },
    // ■ apple IDの課金状況のチェック
    appleAuthCheck(){
      //console.log('appleAuthCheck')
      //this.updatedCheck = false
      //this.updatedCheck = true
      // setintervalで6時間ごとに関数を走らせて状態をチェックをする
      const firebaseCurrentUser = firebase.auth().currentUser
      if (firebaseCurrentUser) {
        const self = this
        const planId = firebase.database().ref('users/' + firebaseCurrentUser.uid + '/setting/sid')
        planId.once('value', function(snapshot) {
          // planidがappleの場合
          if (snapshot.val() === 'apple') {
            //console.log('apple')
            var appleReceiptAuth = firebase.functions().httpsCallable('appleReceiptAuth')
            const appleReceiptAuthCall = async (value) => {
              appleReceiptAuth().then(function(result) {
                // NG（課金されていない）時
                if (result.data.result === 'NG') {
                  //console.log(self.$vs)
                  // アラートでMSGを表示
                  self.$vs.dialog({
                    color:'danger',
                    title: 'アカウント エラー',
                    text: result.data.msg,
                    acceptText: '閉じる',
                    buttonsHidden: true,
                  })
                  // 数秒後にログアウト+リダイレクトでログイン画面へ遷移
                  /*
                  setTimeout(function(){
                    firebase.auth().signOut().then(() => {
                      self.$router.push( { name: 'login' } )
                    })
                  }, 3000);
                  */
                  //setInterval(self.appleAuthCheck, 5000)
                } else {
                  setInterval(self.appleAuthCheck, 60000 * 60 * 6)
                  //setInterval(self.appleAuthCheck, 5000)
                }
                return result
              })
            }
            appleReceiptAuthCall().then(result => {})
          }
        })
      }
    }
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    firebase.auth().onAuthStateChanged(user => {
      // ユーザー情報を更新する
      if (user !== null) {
        const userData = {}
        userData.displayName = user.displayName
        userData.photoURL = user.photoURL
        this.$store.commit('UPDATE_USER_INFO', userData)
      }
    })

  },
  async created() {
    let dir = this.$vs.rtl ? "rtl" : "ltr"
    document.documentElement.setAttribute("dir", dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)

  },
  updated(){
    /*
    if (this.updatedCheck) {
      this.appleAuthCheck()
    } else {
      this.updatedCheck = true
    }
    */
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
}

</script>

<style lang="scss">

</style>
